import { computed } from 'vue';
import { queryOptions, useQuery, useQueryClient } from '@tanstack/vue-query';
import {
  getFrontendPlatformConfig,
  type FrontendPlatformConfig,
} from '@/api/platformConfig';
import { platformConfigKeys } from './keys';
import { PLATFORM_CONFIG_STALE_TIME_MS } from './shared/staleTimes';

export function frontendPlatformConfigOptions() {
  return queryOptions({
    queryKey: platformConfigKeys.frontend(),
    queryFn: ({ signal }) => getFrontendPlatformConfig(signal),
    staleTime: PLATFORM_CONFIG_STALE_TIME_MS,
  });
}

/**
 * Polls every stale time while visible, skips hidden tabs, and refetches on focus once the data is stale.
 */
export function useFrontendPlatformConfigQuery({
  placeholder,
}: {
  placeholder?: () => FrontendPlatformConfig | undefined;
} = {}) {
  const query = useQuery({
    ...frontendPlatformConfigOptions(),
    placeholderData: placeholder,
    refetchInterval: PLATFORM_CONFIG_STALE_TIME_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });

  const platformConfig = computed(
    () => query.data.value ?? ({} as FrontendPlatformConfig)
  );

  return { platformConfig, query };
}

export function useInvalidateFrontendPlatformConfig() {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({ queryKey: platformConfigKeys.frontend() });
}
